
import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Edit, Trash2 } from "lucide-react";
import { CityForm } from "../CityForm";
import { City, Organization } from "@/types/flight";

interface CityListItemProps {
  city: City;
  organizations: Organization[];
  onEdit: () => void;
  onDelete: (id: string) => void;
}

export function CityListItem({ city, organizations, onEdit, onDelete }: CityListItemProps) {
  const [selectedCity, setSelectedCity] = useState<City | null>(null);

  const handleEditSuccess = () => {
    setSelectedCity(null);
    onEdit();
  };

  return (
    <div className="flex items-center justify-between p-3 border rounded-md bg-muted/20 hover:bg-muted/40 transition-colors">
      <div className="flex items-center gap-3">
        <div>
          <div className="font-medium">{city.name}</div>
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <Badge variant="outline" className="text-xs">
              {city.code}
            </Badge>
            <span>•</span>
            <span>
              {city.organization_id ? (
                organizations.find(org => org.id === city.organization_id)?.name || "Unknown"
              ) : (
                "Global"
              )}
            </span>
          </div>
        </div>
      </div>
      <div className="flex gap-2">
        <Dialog 
          open={selectedCity?.id === city.id} 
          onOpenChange={(open) => setSelectedCity(open ? city : null)}
        >
          <DialogTrigger asChild>
            <Button variant="outline" size="sm">
              <Edit className="h-4 w-4" />
            </Button>
          </DialogTrigger>
          <DialogContent>
            <DialogHeader>
              <DialogTitle>Edit City</DialogTitle>
            </DialogHeader>
            <CityForm 
              city={selectedCity}
              organizations={organizations}
              onSubmit={handleEditSuccess}
            />
          </DialogContent>
        </Dialog>
        <Button 
          variant="outline" 
          size="sm" 
          onClick={() => onDelete(city.id)}
        >
          <Trash2 className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
